function formatGuidWithDashes(value) {
  if (typeof value !== 'string') {
    throw new Error('Input must be a string');
  }
  if (value.length !== 32) {
    throw new Error('Input string must be 32 characters long');
  }

  return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(
    16,
    20
  )}-${value.slice(20)}`;
}

function formatGuidWithoutDashes(value) {
  if (typeof value !== 'string') {
    throw new Error('Input must be a string');
  }

  return value.replace(/-/g, '').toUpperCase();
}

export { formatGuidWithDashes, formatGuidWithoutDashes };
